import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OccEndpointsService, RoutingService } from '@spartacus/core';
import {
  combineLatest,
  filter,
  first,
  map,
  Observable,
  Subscription,
} from 'rxjs';
import { CustomInfluenzaService } from '../custom-influenza.service';
import { RESERVATION_ACTION_TYPE, ReservationItem } from 'src/app/shared/model';
import { UserAccountFacade } from '@spartacus/user/account/root';
import {
  ACTIVE_SEASONS,
  DATE_FORMAT,
  OLD_QUOTE_CODE,
  UserUtils,
} from 'src/app/shared';
import { CustomAddToCartService } from 'src/app/custom-add-to-cart/custom-add-to-cart.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ProductDetailsComponent } from 'src/app/custom-add-to-cart/custom-add-to-cart/product-details/product-details.component';
import { WholesalerPharmacyService } from '../wholesaler-pharmacy';

@Component({
  selector: 'app-flu-reservation-details',
  templateUrl: './flu-reservation-details.component.html',
  styleUrls: ['./flu-reservation-details.component.scss'],
})
export class FluReservationDetailsComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  fallbackImage = '../../assets/i18n-assets/sanofiwebb_missing_product.png';
  totalProducts: any;
  totalDoses: number;
  estTotal: any;
  dataForFluConfirmation: any = [];
  productEntries: any = [];
  salesTax = 0;
  currencyIso: any;
  totalwithSavings: number;
  subTotal: any;
  directSavings: any;
  onlineSavings: any;
  baseUrl: any;
  duplicateProductCheckArray: any = [];
  displayProductForUiArray: any = [];
  reservationId: any = '';
  statusDisplay: any = '';
  seasonId: any = '';
  detailedResSubscriber: any;
  estimatedDeliveryDate: any;

  reservationDetails$: Observable<ReservationItem> =
    this.influenzaService.reservationDetails$;

  RESERVATION_ACTIONS = RESERVATION_ACTION_TYPE;

  wholeSalerPharmacy$ =
    this.wholeSalerPharmacyService.getDefaultWholesalerPharmacy();
  reservationSelectedAction: RESERVATION_ACTION_TYPE;
  isDirectUser$ = this.user.get().pipe(map(UserUtils.isDirectUser));
  isPharmacyUser$ = this.user.get().pipe(map(UserUtils.isPharmacyUser));
  DATE_FORMAT = DATE_FORMAT;
  @ViewChild('actionModal') actionModal: TemplateRef<any>;

  inEditableDateRange$ = this.influenzaService.activeSeasons.pipe(
    filter(Boolean),
    map((seasons) => {
      const activeSeason = seasons[0];
      if (activeSeason) {
        const startDate = new Date(activeSeason.startDate);
        const endDate = new Date(activeSeason.endDate);
        const currentDate = new Date();
        return currentDate >= startDate && currentDate <= endDate;
      }
      return false;
    })
  );

  constructor(
    private readonly occEndPoint: OccEndpointsService,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly modalService: NgbModal,
    protected routingService: RoutingService,
    protected user: UserAccountFacade,
    protected addToCart: CustomAddToCartService,
    protected sharedService: SharedService,
    protected wholeSalerPharmacyService: WholesalerPharmacyService
  ) {}

  ngOnInit() {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });

    this.user
      .get()
      .pipe(first(Boolean))
      .subscribe((user) => {
        this.influenzaService.getActiveSeasonsFromDb(user.uid);
      });

    this.subscription.add(
      combineLatest([this.wholeSalerPharmacy$, this.routingService.getParams()])
        .pipe(
          filter(
            ([wholeSaler, routingParams]) => !!wholeSaler && !!routingParams
          ),
          map(([, routingParams]) => {
            return routingParams;
          })
        )
        .subscribe((routingParams) => {
          this.influenzaService.getReservationDetails(
            routingParams.reservationCode
          );
        })
    );
  }
  ngOnDestroy() {
    this.detailedResSubscriber?.unsubscribe();
    this.subscription.unsubscribe();
  }
  displayProduct(dataObj, elem) {
    if (dataObj.prodCode === elem?.product?.code) {
      return dataObj;
    }
    return null;
  }
  onFluPrint() {
    window.print();
  }
  backToDashBoard() {
    this.routingService.goByUrl('/influenza/dashboard');
  }
  productDetails(productDetails) {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: 'product-details-inf-modal',
    });

    modalRef.componentInstance.productDetails = productDetails;
  }

  openProductDetails(productDetails) {
    if (productDetails.basePrice.formattedValue !== undefined) {
      productDetails.product.price = {
        formattedValue: productDetails?.basePrice?.formattedValue,
      };
    }
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: 'product-details-modal',
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = '';
    modalRef.componentInstance.unitSection = 'NoUnits';
  }

  openModal(selectedAction: RESERVATION_ACTION_TYPE) {
    this.reservationSelectedAction = selectedAction;
    const modal = this.modalService.open(this.actionModal);
    modal.dismissed.pipe(first()).subscribe((res) => {
      if (res) {
        this.influenzaService.setReservationStatus(
          this.reservationSelectedAction,
          res
        );
      }
    });
  }

  dismiss(reason?: string) {
    this.modalService.dismissAll(reason);
  }

  editReservation(reservationData: ReservationItem) {
    this.influenzaService
      .editReservation(reservationData?.code)
      .subscribe(() => {
        this.sharedService.setSessionStorage(
          OLD_QUOTE_CODE,
          reservationData?.code
        );
        if (reservationData?.seasonId) {
          this.sharedService.setSessionStorage(
            ACTIVE_SEASONS,
            reservationData?.seasonId
          );
        }
        this.routingService.go('influenza/category');
      });
  }

  downloadExcel() {
    const dataForExcel = [];

    this.reservationDetails$.pipe(first()).subscribe((data) => {
      data.entries?.forEach((entry) => {
        const obj = {
          'Product ID': entry?.product?.code,
          'Qty(unit/doses)':
            entry?.quantity +
            '/' +
            entry?.product?.quantityPerUnit * entry?.quantity,
          'Product Name': entry?.product?.name,
          'Bill to Location': data?.associatedUnit?.billingAddress?.unitID,
          'Ship to Location':
            data?.associatedUnit?.shippingAddresses?.[0]?.unitID,
        };
        dataForExcel.push(obj);
      });
      this.influenzaService.downloadXls(dataForExcel, `${data.code}`);
    });
  }
}
